import * as v from 'valibot';
export const PublicConfig = v.object({
    baseUrl: v.string(),
    emailFromAddress: v.string(),
    secureCookie: v.boolean(),
    version: v.optional(v.string()),
});
//# sourceMappingURL=config.js.map